// Every classification we can resolve a LABEL for, including retired ones —
// used by getPatientClassificationLabel and the appointment form's read-only
// display so historic records still render a name. Not for dropdowns.
export const financialClasses = [
  { label: "Private", value: "01" },
  { label: "GMS", value: "02" },
  { label: "Temporary GMS", value: "04" },
  {
    label: "Doctor Only Visit Card",
    value: "05",
  },
  { label: "Temp DV Card", value: "06" },
  { label: "EHIC", value: "07" },
  // Retired (KIN-1157): HAA is not a patient classification — a patient can hold
  // an HAA number *and* a GMS card, so it moved to patient health identifiers
  // (haaNumber). Kept here only so legacy records still resolve a label; it must
  // never be offered as a new selection.
  { label: "HAA", value: "08" },
];

const RETIRED_FINANCIAL_CLASSES = ["08"];

// The classifications a user may actually choose.
export const selectableFinancialClasses = financialClasses.filter(
  (financialClass) => !RETIRED_FINANCIAL_CLASSES.includes(financialClass.value)
);

export const privateInsuranceProviders = [
  { label: "VHI Healthcare", value: "VHI Healthcare" },
  { label: "Laya Healthcare", value: "Laya Healthcare" },
  { label: "Irish Life Health", value: "Irish Life Health" },
];

export const counties = [
  "Carlow",
  "Cavan",
  "Clare",
  "Cork",
  "Donegal",
  "Dublin",
  "Dublin 1",
  "Dublin 2",
  "Dublin 3",
  "Dublin 4",
  "Dublin 5",
  "Dublin 6",
  "Dublin 6W",
  "Dublin 7",
  "Dublin 8",
  "Dublin 9",
  "Dublin 10",
  "Dublin 11",
  "Dublin 12",
  "Dublin 13",
  "Dublin 14",
  "Dublin 15",
  "Dublin 16",
  "Dublin 17",
  "Dublin 18",
  "Dublin 20",
  "Dublin 22",
  "Dublin 24",
  "Galway",
  "Kerry",
  "Kildare",
  "Kilkenny",
  "Laois",
  "Leitrim",
  "Limerick",
  "Longford",
  "Louth",
  "Mayo",
  "Meath",
  "Monaghan",
  "Offaly",
  "Roscommon",
  "Sligo",
  "Tipperary",
  "Waterford",
  "Westmeath",
  "Wexford",
  "Wicklow",
];

/** Single ordered list for add and edit patient forms */
export const titleOptions = [
  "Mr",
  "Mrs",
  "Miss",
  "Ms",
  "Dr",
  "Master",
  "Prof",
  "Fr",
  "Sr",
];

export const sexOptions = ["Male", "Female"];

export const nextOfKinRelationshipOptions = [
  "Spouse",
  "Partner",
  "Parent",
  "Child",
  "Sibling",
  "Friend",
  "Other",
];

export const yesNoOptions = ["Yes", "No"];
